<template>
  <Form
    ref="queryForm"
    class="form-flex label-hide opacity"
    label-position="left"
    :label-width="80"
    :model="queryModel"
    :rules="rules"
    @submit.native.prevent
  >   
  <h2>傷害險</h2>
    <DatePickerInput v-model="queryModel.accidentdate" placeholder=" 年 / 月/ 日" label="生效日期" prop="accidentdate" />    
    <BaseVueSelect
      v-model="queryModel.expectPremium"
      label="職業類別"
      prop="expectPremium"
      :options="options"
    />   
    
    <div class="form-footer clearfix mb-s"> 
      <Button
        class="pull-right btn-primary btn-m btn-shadow"
        :loading="loading"
        @click="handleSubmit"
      >
        <span v-if="!loading">快速試算保費</span>
        <span v-else>請稍候</span>
      </Button>
    </div>
    <div class="notice">      
      <p>* 適合職業類別為1~3類。</p>
      <p>* 保險期間為選取時間零時起。</p>
      <p>* 依據法令規定未滿20歲者申請投保，請洽專員辦理。</p>
    </div>
  </Form>
</template>

<script>
//import axios, { generateAuthPostConf  } from '@/utils/axios';
// date-fns
import differenceInCalendarDays from "date-fns/difference_in_calendar_days";
//import differenceInHours from "date-fns/difference_in_hours";
import getTime from "date-fns/get_time";
// component
import { Form, Button } from "iview";
//import GroupRadio from "@/components/forms/elements/GroupRadio";
//import DateTimePickerInput from "@/components/forms/elements/DateTimePickerInput";
import DatePickerInput from "@/components/forms/elements/DatePickerInput";
import BaseVueSelect from "@/components/forms/elements/BaseVueSelect";
// options & radios
//import { abroad as radios } from "@/staticData/radios";
// default model
import {
  accidentModel,
  accidentRules,
  options
} from "@/utils/asyncValidator/queryForms";
//import Cookies from 'js-cookie';
export default {
  components: {
    Form,
    Button,
    //GroupRadio,
    //DateTimePickerInput,
    DatePickerInput,
    BaseVueSelect
  },
  props: {
    model: {
      type: Object,
      default: () => accidentModel
    },
    /*carno: {
        type: String,
        default() {
          //console.log(this.carno);
          return this.carno ==null?null:this.carno;
        }
      },*/
    loading: {
      type: Boolean,
      default: false
    },
    handleQuery: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    const startTimeValidator = (rule, value, callback) => {     
      //const { date } = value+" 00:00";
      //const date = new Date(`${value} 00:00`); 
      const date =value;
      //console.log(value);
      const diffter = differenceInCalendarDays(`${date}`, new Date());
      //const diffter = new Date(`${date}`) - new Date();
      //console.log(123);
      //console.log("isnan:"+isNaN(diffter));
       //console.log(new Date(`${value} 00:00`));
       //console.log(111);
      let errorMsg = [];
      //console.log("value=='':"+ value=="");
      if (isNaN(diffter)|| value=='') {
        //errorMsg.push("請選擇您旅遊的出發日期");
        return callback(new Error("請選擇您傷害險的生效日期!"));
        //console.log(456);
        //console.log(value);
      }
     /* if (!time) {
        //errorMsg.push("請選擇您旅遊的出發時間");
        return callback(new Error("請選擇您旅遊的保險開始時間"));
      }*/
       //console.log(789);
      //console.log(diffter);
      if (diffter < 1) {
        //Wen Add 2019/11/28 控制無法選擇過去的時間點
       // console.log(`${date} ${time}`);
        //console.log("InsuAccidentQueryForm" + diffter);
        //errorMsg.push("出發時間需大於目前時間1小時");
        return callback(new Error("保險起始日是從午夜12時起"));
      }
      callback();
    };
    /*const endTimeValidator = (rule, value, callback) => {
      if (this.isEmpty.end) return callback(new Error("請選擇您的結束時間"));
      const {
        queryModel: { endTime, startTime }
      } = this;
      const sDateStr = `${startTime.date} ${startTime.time}`;
      const eDateStr = `${endTime.date} ${endTime.time}`;
      const diffHours = differenceInHours(eDateStr, sDateStr);
      //const diffter = differenceInHours(sDateStr, new Date());
      //if (diffter < 1) return callback(new Error("出發時間需大於目前時間1小時"));//Wen Add 2019/11/28 控制無法選擇過去的時間點
      if (diffHours < 24) return callback(new Error("投保總時數需大於24小時"));
      callback();
    };*/
    const rules = {
      ...accidentRules,      
      accidentdate: { validator: startTimeValidator , trigger: "validate" }
    };
    const queryModel = this.$cloneDeep(this.model);
   
//    console.log("queryModel.carNo0:"+this.carno);
//console.log("queryModel.carNo3:"+this.carno);
    return {
      queryModel,
      /*endTimeOptions: {
        disabledDate: currDate => {
          const { queryModel, isEmpty } = this;
          if (isEmpty.start) return;
          return (
            currDate.valueOf() < getTime(queryModel.startTime.date) + 86400
          );
        }
      },*/
     // endDisabledHours: false,
      options: options.expectPremium.accident,
      rules,
      //radios
    };
  },
  watch: {
    "queryModel.accidentdate"() {
      const {
        queryModel: { accidentdate }
      } = this;
     /* if (startTime.time) {
        endTime.time = startTime.time;
        this.endDisabledHours = true;
      } else {
        this.endDisabledHours = false;
      }*/
    }
  },
  computed: {
    isEmpty() {
      const { startTime } = this.queryModel;
      return {
        start: Object.values(startTime).some(val => !val),
        //end: Object.values(endTime).some(val => !val)
      };
    },
    /*totalDays() {
      const {
        isEmpty,
        queryModel: { startTime, endTime }
      } = this;
      const isSelectBoth = Object.values(isEmpty).every(val => val === false);
      if (!isSelectBoth) return null;
      const day = differenceInCalendarDays(endTime.date, startTime.date);
      return endTime.time > startTime.time ? day + 1 : day;
    },*/
    premiumLabel() {
      const {
        queryModel: { expectPremium },
        options
      } = this;
      if (!expectPremium) return null;
      const { label } = options.find(option => option.value === expectPremium);
      //console.log("expectPremium:" +expectPremium);
      return label;
    },/*
    disabledHours() {
      const {
        queryModel: { endTime, startTime },
        isEmpty
      } = this;
      if (isEmpty.start) return [];
      const diffDays = differenceInCalendarDays(endTime.date, startTime.date);
      if (diffDays !== 1) return [];
      const [hours] = startTime.time.split(":");
      return Array.from({ length: parseInt(hours, 10) }, (x, i) => i);
    }*/
  },
  methods: {
    validate() {
      return this.$refs.queryForm.validate(v => v);
    },
    async handleSubmit() {
      const isValid = await this.validate();      
      if (!isValid) return;
      const { queryModel, premiumLabel } = this;
      const type = "accident";
      const tips = {  premiumLabel };
      this.handleQuery({ type, tips, ...queryModel });
    }    
  }
};
</script>
